import React from 'react';
import { Button } from './Button';

interface FooterProps {
  onOpenPrivacyModal: () => void;
  onOpenCookieModal: () => void;
  onOpenLegalNoticeModal: () => void;
  onOpenAboutUsModal: () => void;
  onOpenContactModal: (subject?: string) => void;
}

export const Footer: React.FC<FooterProps> = ({
  onOpenPrivacyModal,
  onOpenCookieModal,
  onOpenLegalNoticeModal,
  onOpenAboutUsModal,
  onOpenContactModal,
}) => {
  return (
    <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          {/* Columna 1: Logos */}
          <div className="space-y-2">
            <div className="text-2xl font-bold text-white">
              Multas<span className="text-yellow-400">.EU</span>
            </div>
            <div>
              <a 
                href="https://peritajes.eu" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-xl font-semibold text-white inline-block transition-all duration-300 hover:text-yellow-400 hover:scale-105"
              >
                Peritajes<span className="text-yellow-400">.EU</span>
              </a>
            </div>
            <div>
              <a 
                href="https://juzgados.eu" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-xl font-semibold text-white inline-block transition-all duration-300 hover:text-yellow-400 hover:scale-105"
              >
                Juzgados<span className="text-yellow-400">.EU</span>
              </a>
            </div>
          </div>
          
          {/* Columna 2: Contacto */}
          <div>
            <h5 className="text-lg font-semibold text-white mb-3">Contacto</h5>
            <Button onClick={() => onOpenContactModal('Consulta desde el pie de página')} variant="primary">
              Enviar Consulta
            </Button>
            <p className="text-sm text-slate-500 mt-3">
              O escríbenos a:<br />
              <a href="mailto:informacion@multas.eu" className="hover:text-yellow-400 transition-colors">informacion@multas.eu</a>
            </p>
          </div>
          
          {/* Columna 3: Enlaces */}
          <div>
            <h5 className="text-lg font-semibold text-white mb-2">Enlaces</h5>
            <ul className="space-y-1">
              <li>
                <button onClick={onOpenPrivacyModal} className="hover:text-yellow-400 transition-colors text-left">
                  Política de Privacidad
                </button>
              </li>
              <li>
                <button onClick={onOpenCookieModal} className="hover:text-yellow-400 transition-colors text-left">
                  Política de Cookies
                </button>
              </li>
              <li>
                <button onClick={onOpenLegalNoticeModal} className="hover:text-yellow-400 transition-colors text-left">
                  Aviso Legal
                </button>
              </li>
              <li>
                <button onClick={onOpenAboutUsModal} className="hover:text-yellow-400 transition-colors text-left">
                  Quiénes Somos
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-sm italic text-slate-400 mb-4">
            Esta página está creada prácticamente en su totalidad con IA, con lo que está en constante desarrollo. No te extrañe que un día veas una opción y al día siguiente no esté o se haya duplicado. Si lo detectas, por favor avísanos desde la sección de contacto. Te lo agradeceremos. Básicamente, ante la duda pregúntanos.
          </p>
          <p className="text-base font-medium text-slate-300 mb-2">Desde 1.999 Ayudandote</p>
          <p className="text-sm">&copy; 2024 Grupo Multas (Andorra) - Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};